import React from 'react';
import { useTranslations } from 'next-intl';
import { EmailForm, OTPForm } from './components';
import { useAuthOTP } from '@/hooks/business/useAuthOTP';
import { useEmailInputFocus } from '@/hooks/ui/useEmailInputFocus';
import { OTPButtonProps } from '@/lib/types/auth';

const AuthWithOTPButton: React.FC<OTPButtonProps> = ({
  role,
  onLoginSuccess,
  welcomeText,
  welcomeDescription,
  verificationText,
}) => {
  const t = useTranslations('AuthWithOTPButton');

  // Use translated defaults if not provided as props
  const translatedWelcomeText = welcomeText || t('welcome');
  const translatedWelcomeDescription = welcomeDescription || t('welcomeDescription');
  const translatedVerificationText = verificationText || t('verificationText');

  // Business logic hook
  const {
    authState,
    handleSendCode,
    handleOTPChange,
    handleOTPComplete,
    resetToEmailStep,
    isSubmittingCode,
    isSendingCode,
    isLoading,
  } = useAuthOTP({ role, onLoginSuccess });

  // UI hook for email input focus
  const { setInputElement } = useEmailInputFocus(authState.showCodeInput);

  return (
    <div className='w-full relative'>
      <h3 className='text-2xl md:text-3xl font-medium text-center'>
        {!authState.showCodeInput ? translatedWelcomeText : t('enterCode')}
      </h3>
      <h5 className='text-sm md:text-sm text-center font-normal mt-2 text-muted-foreground mb-8'>
        {!authState.showCodeInput
          ? translatedWelcomeDescription
          : `${translatedVerificationText} ${authState.emailAddress}`}
      </h5>

      {!authState.showCodeInput ? (
        <EmailForm
          onSubmit={handleSendCode}
          isSendingCode={isSendingCode}
          setInputElement={setInputElement}
        />
      ) : (
        <OTPForm
          otpValue={authState.otpValue}
          isLoading={isLoading}
          isSubmittingCode={isSubmittingCode}
          onOTPChange={handleOTPChange}
          onOTPComplete={handleOTPComplete}
          onBack={resetToEmailStep}
        />
      )}
    </div>
  );
};

export default AuthWithOTPButton;
